/* eslint-disable */
import { useState, Fragment, useEffect } from 'react';
import { QueryClientProvider, QueryClient, useQuery } from '@tanstack/react-query';
import { useWaTag } from '../../api';

export default function SetTagBox({ event, setNodes, wa_authKey, waEmployee }) {
    const queryClient = new QueryClient();

    const [empID, setEmpID] = useState("")
    const [prevEmpID, setPrevEmpID] = useState(""); // Track previous empID

    useEffect(() => {
        if(empID != ""){
            if (empID !== prevEmpID) {
                setPrevEmpID(empID); // Update previous empID when it changes
              }
        }

      }, [empID]); // Runs only when empID changes

    const TagBox = () => {
        const [refresher, setRefresher] = useState(false)
        const tagQuery = useWaTag(empID, prevEmpID);


        const addTag = (val) => {
            setNodes((nds) =>
                nds.map((node) => {
                    if (node.id == event.id) {
                        const tags = node.data.value.api.tags || [];
                        const alreadyAdded = tags.some((i) => i.id == val);

                        if (!alreadyAdded) {
                            const tagToAdd = tagQuery.data.find((i) => i.id == val);
                            if (tagToAdd) {
                                node.data.value.api.tags = [...tags, tagToAdd];
                            }
                        }
                    }
                    return node;
                })
            );
            setRefresher(!refresher)
        };

        const removeTag = (id) => {
            setNodes((nds) =>
                nds.map((node) => {
                    if (node.id == event.id) {
                        node.data.value.api.tags = node.data.value.api.tags.filter((i) => i.id !== id);
                    }
                    return node;
                })
            );
            setRefresher(!refresher)
        };

       


        if (tagQuery.isLoading) return <span>Loading...</span>

        if (tagQuery.isError) {
            return <span>Error loading tags</span>;
        }

        const AddedTagBox = () => {
            return event.data?.value?.api?.tags?.map((i) => (
                <button key={i.id} className='p-1 m-1 rounded'
                    style={{ backgroundColor: i.tag_colour }}
                    onClick={() => removeTag(i.id)}>
                    {i.name} ×
                </button>
            ));
        };



        return (
            <Fragment>
                <select className="form-select mb-2" onChange={(e) => addTag(e.target.value)}>
                    <option value="">Select Tag</option>
                    {tagQuery.data?.map(i => (<option key={i.id} value={i.id}>{i.name}</option>))}
                </select>
                <AddedTagBox />
            </Fragment>
        )
    }
    const employeeChange = (value) => {
        setNodes((nds) => nds.map((node) => {
            if (node.id == event.id) {
                node.data.value.api.tags = [];
                node.data.value.api.emp = value;
            }
            return node;
        }));
        setEmpID(value);
    };


    return (
        <div className="card-body mt-0">
            <div className="contact_add_div">
                <div className="mx-auto">
                    <div className="body_teml mt-2">
                        <label className="header_heading">
                            <i className="fa-solid fa-file-lines"></i> Body
                        </label>
                        <QueryClientProvider client={queryClient}>
                            <select className="form-select mb-2" onChange={(e) => employeeChange(e.target.value)}>
                                <option value="" selected disabled>Select Employee</option>
                                {
                                    Object.entries(waEmployee.data.data).map(([key, employees]) =>
                                        employees.map((employee) => (<option key={employee.empid} value={employee.empid}>{employee.emp_name} ({key})</option>))
                                    )
                                }
                            </select>
                            {empID && <TagBox />}
                        </QueryClientProvider>
                    </div>
                </div>
            </div>
        </div>
    );
}